<template>
  <login-nav :lang="lang" @changeLang="onChangeLang"></login-nav>
  <div class="login-container center p-40" style="min-height: calc(100vh)">
    <div class="container">
      <img class="pt-30" src="@/assets/image/logo.png" />
      <br />
      <form>
        <el-input
          class="mb-16 mt-30"
          v-model="email"
          inputmode="text"
          :placeholder="$t('email')"
        ></el-input>
        <div v-if="showPassword" class="password-div">
          <el-input
            id="passwordinput"
            class="mb-16"
            type="text"
            v-model="password"
            inputmode="password"
            :placeholder="$t('password')"
          ></el-input>
          <fa icon="eye-slash" class="fa" @click="showPasswordToggle" />
        </div>
        <div v-else class="password-div">
          <el-input
            id="passwordinput"
            class="mb-16"
            type="password"
            v-model="password"
            inputmode="password"
            :placeholder="$t('password')"
          ></el-input>
          <fa icon="eye" class="fa" @click="showPasswordToggle" />
        </div>
      </form>
      <div
        style="
          text-align: right;
          color: #206b5e;
          text-decoration: underline;
          font-weight: bold;
          padding-top: 0px;
          cursor: pointer;
        "
      >
        <a ref="/fogot">{{ $t("forgot") }}</a>
      </div>

      <div
        style="width: 14rem; height: 3rem; font-size: 1.5rem"
        class="btn-48 btn-primary btn m-auto mt-15"
        @click="login"
      >
        {{ $t("login") }}
      </div>
      <div style="margin-top: 2rem; font-size: 1.5rem; font-weight: bold">
        {{ $t("or") }}
      </div>

      <!-- <div
          class="btn"
          style="height:3rem;font-size:1.5rem;background:white;border:1px solid #D5E3D5;border-radius:0.5rem;margin-top:2rem;"
          @click="loginPlus"
        >
          {{ $t('loginPlus') }}
        </div> -->
      <div
        style="
          height: 3rem;
          font-size: 1.5rem;
          background: white;
          border: 1px solid #d5e3d5;
          border-radius: 0.5rem;
          margin-top: 2rem;
        "
        class="btn"
        @click="loginPlusV5"
      >
        {{ $t("loginPlusV5") }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import LoginNav from "@/components/LoginNav.vue";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
import axios from "axios";
import * as config from "@/assets/js/config.js";
var md5 = require("md5");

export default defineComponent({
  name: "Login",
  components: {
    LoginNav,
  },
  data() {
    return {
      lang: "th",
      email: null,
      password: null,
      showPassword: false,
    };
  },
  methods: {
    onChangeLang(value) {
      this.lang = value;
      window.localStorage.setItem("lang", value);
    },
    showPasswordToggle() {
      this.showPassword = !this.showPassword;
      console.log(window.$());
    },
    login() {
      this.isLoading = true;
      var authenticationData = {
        Username: this.email,
        Password: this.password,
      };
      var authenticationDetails =
        new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
      this.$store.state.userPool = new AmazonCognitoIdentity.CognitoUserPool(
        config.poolData
      );
      var userData = {
        Username: this.email,
        Pool: this.$store.state.userPool,
      };

      console.log(userData);
      this.$store.state.cognitoUser = new AmazonCognitoIdentity.CognitoUser(
        userData
      );
      this.$store.state.cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: () => {
          if (!this.callback) {
            this.callback = true;
            this.$store.state.authenticated = true;
            this.$store.state.username = this.email;
            this.username = this.email;
            const cognitoUser = this.$store.state.userPool.getCurrentUser();
            if (cognitoUser != null) {
              cognitoUser.getSession((err, session) => {
                if (err) {
                  alert("error :" + err);
                } else if (!session.isValid()) {
                  alert("Invalid session.");
                } else {
                  console.log(session);
                  this.$cookies.set(
                    "access_token",
                    session.getIdToken().getJwtToken()
                  );
                  this.$cookies.set(
                    "username",
                    session.getAccessToken().payload.sub
                  );
                  this.$cookies.set(
                    "refresh_token",
                    session.getRefreshToken().token
                  );
                  this.$cookies.set("lang", this.lang);
                  this.$cookies.set("channel", "supperapp");
                  // this.$router.push("/home");

                  window.location.href = "/home";
                }
              });
            } else {
              alert("User not found.");
            }
          }
        },
        onFailure: (err) => {
          console.log("sign in failure");
          alert("sign in failure :" + err.message);
        },
        newPasswordRequired: (userAttributes) => {
          // User was signed up by an admin and must provide new
          // password and required attributes, if any, to complete
          // authentication.
          // console.log(userAttributes);
          // the api doesn't accept this field back
          delete userAttributes.email_verified;
          delete userAttributes.phone_number_verified;
          delete userAttributes.phone_number;
          delete userAttributes.email;

          // store userAttributes on global variable
          this.sessionUserAttributes = userAttributes;
          this.page = "changepass";
        },
      });
    },
    loginPlus() {
      this.isLoading = true;
      axios
        .post(
          process.env.VUE_APP_GW_URL,
          {
            email: this.email,
            password: this.password,
          },
          {
            headers: {
              "x-api-key": process.env.VUE_APP_API_KEY,
            },
          }
        )
        .then((response) => {
          let access = response.data;
          if (access) {
            this.$cookies.set("plus_access_token", access.access_token);
            this.$cookies.set("lang", this.lang);
            this.$cookies.set("channel", "plus");
            this.$cookies.set("memberId", access.guid);
            console.log();
            this.$router.push({
              path: "/home",
              query: { memberId: access.guid, lang: this.lang },
            });
          } else {
            alert("error: no return token");
          }
          this.isLoading = false;
        })
        .catch((error) => {
          alert("error: " + error);
          this.isLoading = false;
        });
    },
    loginPlusV5() {
      this.isLoading = true;
      const params = new URLSearchParams();
      params.append("grant_type", "password");
      params.append("client_id", process.env.VUE_APP_PLUS_CLIENT_ID);
      params.append("client_secret", process.env.VUE_APP_PLUS_CLIENT_SECRET);
      params.append("scope", "*");
      params.append("username", this.email);
      params.append("password", md5(this.password));
      axios
        .post(process.env.VUE_APP_PLUS_URL + "/api/v5/oauth2/token", params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((response) => {
          this.access = response.data.access_token;
          if (this.access) {
            this.$cookies.set("plus_access_token", this.access);
            this.$cookies.set("lang", this.lang);
            this.$cookies.set("channel", "plusV5");
            // console.log(this.access)
            // this.$router.push("/home");
            window.location.href = "/home";
            //   "/?memberId=" + this.access.guid + "&lang=th";
          } else {
            alert("error: no return token");
            this.isError = true;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          alert("error: " + error);
          this.isError = true;
          this.isLoading = false;
        });
    },
    validNewPassword(v) {
      if (!v) {
        return "requiredPass";
      }
      if (v.length < 8 || v.length > 20) {
        return "more8TO20Pass";
      }
      if (!/^(?=.*[0-9])/.test(v)) {
        return "numberPass";
      }
      if (!/^(?=.*[a-z])/.test(v)) {
        return "lowerPass";
      }
      if (!/^(?=.*[A-Z])/.test(v)) {
        return "upperPass";
      }
      if (!/^(?=.*[!@#$%^&*"])/.test(v)) {
        return "SpecialCharPass";
      }
      return null;
    },
    handleNewPassword() {
      this.isLoading = true;
      if (this.validNewPassword(this.newPassword)) {
        this.errmsg = "new password pattern wrong.";
        alert("error: " + this.errmsg);
        this.isLoading = false;
      }
      if (this.newPassword != this.confirmPassword) {
        this.errmsg = "new password and confirm password not match";
        alert("error: " + this.errmsg);
        this.isLoading = false;
      } else {
        this.$store.state.cognitoUser.completeNewPasswordChallenge(
          this.newPassword,
          this.sessionUserAttributes,
          {
            onSuccess: () => {
              if (!this.callback) {
                this.callback = true;
                console.log("sign in success");
                this.$store.state.authenticated = true;
                this.$store.state.username = this.email;
                this.username = this.email;

                const cognitoUser = this.$store.state.userPool.getCurrentUser();
                if (cognitoUser != null) {
                  cognitoUser.getSession((err, session) => {
                    if (err) {
                      alert(err);
                    } else if (!session.isValid()) {
                      alert("Invalid session.");
                    } else {
                      this.$cookies.set(
                        "access_token",
                        session.getIdToken().getJwtToken()
                      );
                      this.$cookies.set(
                        "refresh_token",
                        session.getRefreshToken().token
                      );
                      this.$cookies.set("lang", this.lang);
                      this.$cookies.set("channel", "supperapp");

                      window.location.href = "/home";
                      // this.$router.push("/home");
                    }
                  });
                } else {
                  alert("User not found.");
                }
                this.isLoading = false;

                // this.$router.push("/booking");
              }
            },
            onFailure: (err) => {
              this.isLoading = false;
              alert("error: " + err.message);
            },
          }
        );
      }
    },
  },
});
</script>
